import script from "./EzTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./EzTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./EzTableRow.vue?vue&type=style&index=0&id=ab012628&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab012628"]])

export default __exports__